import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { RouterModule } from '@angular/router';

import { Error404Component } from './errors/Error404.component';
import { SidenavComponent } from './layout/sidenav/sidenav.component';
import { ToolbarComponent } from './layout/toolbar/toolbar.component';
import { EnsureModuleLoadedOnceGuard } from './ensure-module-loaded-once.guard';
import { SharedModule } from '../shared/shared.module';
import { MarketsLookupService } from './services/markets-lookup.service';
import { SpinnerComponent } from "./layout/spinner/spinner.component";

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule, SpinnerComponent],
  declarations: [
    Error404Component,
    SidenavComponent,
    ToolbarComponent,
  ],
  exports: [
    SidenavComponent
  ],
  providers: [MarketsLookupService],
})
export class CoreModule extends EnsureModuleLoadedOnceGuard {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    super(parentModule);
  }
}
